module.exports = __webpack_public_path__ + "static/media/esb.fefcc5ca.png";